<script lang="ts" setup>
import ProductFact from '~/components/products/ProductFact.vue'
import ProductGrayButton from "~/components/products/ProductGrayButton.vue";
import ProductTextStrong from '~/components/products/ProductTextStrong.vue'
import { useResponsiveScreenFacade } from '~/composables/responsive-screen-facade'
import type { ProductData } from '~/types/products'

const props = defineProps<{
  productData: ProductData
}>()

const { isMd } = useResponsiveScreenFacade()

const visibleCount = ref(4)

const visibleFacts = computed(() =>
  props.productData.relationships.facts.data.slice(0, visibleCount.value)
)

function showMore (): void {
  visibleCount.value += 4
}

onMounted(() => {
  if (!isMd.value) {
    visibleCount.value = props.productData.relationships.facts.data.length
  }
})
</script>

<template>
  <div class="flex flex-col items-stretch md:flex-row">
    <ProductTextStrong class="min-w-full md:min-w-[143px] lg:min-w-[33%]" text="Интересные факты" />

    <div>
      <Carousel class="mt-2 md:mt-0" drag-free :show-buttons="false">
        <div class="flex items-stretch md:flex-wrap">
          <ProductFact
            v-for="x in visibleFacts"
            :key="x.id"
            class="mb-3 mr-3 w-[calc(50%-12px)] last:mr-0"
            :product-fact-data="x"
          />
        </div>
      </Carousel>

      <ProductGrayButton
        v-if="visibleCount < productData.relationships.facts.data.length"
        class="hidden md:mt-5 md:block"
        title="Показать ещё"
        @click.prevent="showMore"
      />
    </div>
  </div>
</template>
